import { MenuItem, Select } from '@mui/material'
import React from 'react'
import { RateType, useRatesQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useLocalizeString from 'src/app/hooks/current-locale/use-localized-string'
import { useMemo } from 'react'
import { Checkbox, Typography } from '@vapor/material'

type RatesMultipleSelectProps = {
  propertyId: string
  value: string[]
  onChange: (ratesId: string[]) => void
  disabled: boolean
  rateTypesToShow?: RateType[]
  placeholderWhenEmpty?: string
  small?: boolean
  addRateIdToOption?: string
}

export default function RatesMultipleSelect(props: RatesMultipleSelectProps) {
  const { id: tenantId } = useTenant()
  const { propertyId, value, onChange, disabled } = props
  const localizeString = useLocalizeString()

  const { data, loading } = useRatesQuery({
    variables: {
      filter: {
        tenantId: {
          eq: tenantId,
        },
        propertyId: {
          eq: propertyId,
        },
      },
    },
  })

  const options = useMemo(() => {
    return (
      data?.rates
        ?.filter((rate) => {
          if (props.addRateIdToOption && props.addRateIdToOption === rate.id) return true
          return (props.rateTypesToShow === undefined || props.rateTypesToShow.includes(rate.type)) && (rate.affiliatedCompaniesId ?? []).length === 0
        })
        .map((rate) => (
          <MenuItem key={rate.id} value={rate.id}>
            <Checkbox size="small" checked={value.indexOf(rate.id) > -1} />
            <Typography variant="body">{localizeString(rate.name)}</Typography>
          </MenuItem>
        )) ?? []
    )
  }, [data?.rates, props.rateTypesToShow, value, props.addRateIdToOption, localizeString])

  return (
    <Select
      size={props.small ? 'small' : undefined}
      fullWidth
      onChange={(event) => {
        if (options.length > 0) {
          onChange(event.target.value as string[])
        }
      }}
      value={options.length > 0 ? (Array.isArray(value) ? value : []) : ['default']}
      multiple
      disabled={loading || disabled || options.length === 0}
      renderValue={(selected) => ((selected as string[] | undefined | null) ?? []).map((id) => localizeString(data?.rates?.find((cc) => cc.id === id)?.name)).join(', ')}
    >
      {options.length > 0 ? (
        options
      ) : (
        <MenuItem key={'default'} value={'default'}>
          <Typography variant="body">{props.placeholderWhenEmpty}</Typography>
        </MenuItem>
      )}
    </Select>
  )
}
